import classNames from "classnames";
import TextInput, { TextInputPropsType } from "components/TextInput";
import { FC } from "react";

import { ReactComponent as CloseIcon } from "assets/images/common/close-round.svg";
import { ReactComponent as SearchIcon } from "assets/images/common/search.svg";

type PropTypes = {
  className?: string;
} & TextInputPropsType;

const SearchInput: FC<PropTypes> = ({ onChange, className, ...props }) => {
  const handleClear = () => {
    onChange?.({
      target: { name: props?.name ?? "", value: "" } as unknown as EventTarget & HTMLInputElement,
    } as unknown as React.ChangeEvent<HTMLInputElement>);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e);
  };

  return (
    <TextInput
      afterIcon={
        <div>
          {!!props.value && (
            <span onClick={handleClear} className={"search-input__close-icon"}>
              <CloseIcon />
            </span>
          )}

          <span className={"search-input__search-icon"}>
            <SearchIcon />
          </span>
        </div>
      }
      onChange={handleChange}
      className={classNames("search-input", className)}
      {...props}
    />
  );
};

export default SearchInput;
